import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/ProjectChecklist.scss';
import { t, tn } from '../../i18n';

const CHECKLIST_QUERY = gql`
  query ProjectChecklist($id: ID!) {
    project(id: $id) {
      id
      name
      main_page_id
      pages {
        id
        name
        cells {
          id
        }
      }
      latest_version {
        version
      }
    }
  }
`;

const previewKey = (projectId) => `tsk-previewed-${projectId}`;
const readPreviewed = (projectId) => {
  try { return window.localStorage.getItem(previewKey(projectId)) === '1'; } catch (e) { return false; }
};

// Guide « pour mettre votre interface en ligne », affiché quand aucune page n'est ouverte.
class ProjectChecklist extends Component {

  state = { previewed: readPreviewed(this.props.projectId) };

  markPreviewed = () => {
    try { window.localStorage.setItem(previewKey(this.props.projectId), '1'); } catch (e) { /* ignore */ }
    this.setState({ previewed: true });
  };

  render() {
    const { projectId } = this.props;
    return (
      <Query query={CHECKLIST_QUERY} variables={{ id: projectId }} fetchPolicy='cache-and-network'>
        {({ data }) => {
          const project = data && data.project;
          if (!project) return null;
          const pages = project.pages || [];
          const withModules = pages.find((p) => (p.cells || []).length > 0);
          const firstPage = pages.find((p) => p.id === project.main_page_id) || pages[0];
          const steps = [
            {
              done: pages.length > 0,
              title: t('ui.ck.s1.title'),
              text: t('ui.ck.s1.text'),
            },
            {
              done: !!withModules,
              title: t('ui.ck.s2.title'),
              text: t('ui.ck.s2.text'),
              action: firstPage && <Link className='tsk-checklist__cta' to={`/project/${projectId}/page/${firstPage.id}`}>{t('ui.ck.s2.open', { name: firstPage.name })}</Link>,
            },
            {
              done: this.state.previewed,
              title: t('ui.ck.s3.title'),
              text: t('ui.ck.s3.text'),
              action: <a className='tsk-checklist__cta' href={`/project/${projectId}/preview`} target='_blank' rel='noopener noreferrer' onClick={this.markPreviewed}>{t('ui.ck.s3.open')}</a>,
            },
            {
              done: !!project.latest_version,
              title: t('ui.ck.s4.title'),
              text: t('ui.ck.s4.text'),
            },
          ];
          const doneCount = steps.filter((s) => s.done).length;
          return (
            <div className='tsk-checklist'>
              <h2 className='tsk-checklist__title'>{t('ui.ck.title', { name: project.name })}</h2>
              <p className='tsk-checklist__sub'>{doneCount === steps.length ? t('ui.ck.all_done') : t('ui.ck.progress', { done: doneCount, total: steps.length })}</p>
              <div className='tsk-checklist__bar'><span style={{ width: `${(doneCount / steps.length) * 100}%` }} /></div>
              <ol className='tsk-checklist__steps'>
                {steps.map((step, i) => (
                  <li key={step.title} className={step.done ? 'is-done' : ''}>
                    <span className='tsk-checklist__check'>{step.done ? <FontAwesomeIcon icon={['fas', 'check-circle']} /> : i + 1}</span>
                    <div>
                      <strong>{step.title}</strong>
                      <p>{step.text}</p>
                      {step.action}
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default ProjectChecklist;
